import React from 'react';
export default function PageNotFound() {
  return (
    <div className='flex-1 flex'>
      <div className='w-full'>
        <img className='w-[100%]' style={{objectFit:'contain'}} src='/comingsoon.png'/>
      </div>
    </div>
  );
}

